<mat-dialog-content>
  <div id="acknowledge-dialog-wrapper">
    <div id="acknowledgementTitle">{{data.title}}</div>
    <div id="acknowledgementDetails">{{data.question}}</div>
    <div id="buttons-wrapper">
      <button id="btn-ok" (click)="acknowledge()">Ok</button>
    </div>
  </div>
</mat-dialog-content>
